import { css } from "../../../styled-system/css";
import { t } from "../../libs/i18n";

type Props = {
  onClickClose: () => void;
  onClickReload: () => void;
};

export function NotSupportedError({ onClickClose, onClickReload }: Props) {
  return (
    <div
      className={css({
        bg: "background.background",
        minH: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: "24px",
      })}
    >
      <section
        className={css({
          bg: "white",
          borderRadius: "16px",
          w: "full",
        })}
      >
        <div
          className={css({
            p: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "16px",
          })}
        >
          <h2
            className={css({
              fontSize: "20px",
              fontWeight: "bold",
              color: "text.primary",
            })}
          >
            {t("アプリの更新が必要です")}
          </h2>

          <button
            type="button"
            onClick={onClickReload}
            className={css({
              bg: "surface.accentPrimary",
              color: "white",
              w: "full",
              mt: "4",
              rounded: "xl",
              p: "2",
            })}
          >
            {t("再読み込み")}
          </button>
          <button
            type="button"
            className={css({
              bg: "surface.feedback",
              color: "white",
              w: "full",
              rounded: "xl",
              p: "2",
            })}
            onClick={onClickClose}
          >
            {t("ミニアプリを閉じる")}
          </button>
        </div>
      </section>
    </div>
  );
}
